import { inject, provideAppInitializer } from '@angular/core';

export const BASIC_THEME_NAV_ITEM_PROVIDERS = [
  provideAppInitializer(() => {
    configureNavItems();
  }),
];

export function configureNavItems() {
  // Navigation items will be configured by the main app
}
